import React, { useState, useEffect } from 'react';

const SimpleTest: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'];

  const handleKeyDown = (e: React.KeyboardEvent) => {
    console.log('SimpleTest Key:', e.key, 'selectedIndex:', selectedIndex);
    
    if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const newIndex = selectedIndex < items.length - 1 ? selectedIndex + 1 : 0;
      console.log('SimpleTest ArrowDown: changing from', selectedIndex, 'to', newIndex);
      setSelectedIndex(newIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const newIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
      console.log('SimpleTest ArrowUp: changing from', selectedIndex, 'to', newIndex);
      setSelectedIndex(newIndex);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setSelectedIndex(0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          minWidth: '300px'
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <h3>Simple Test - selectedIndex: {selectedIndex}</h3>
        <input 
          type="text" 
          placeholder="Type here..."
          onKeyDown={handleKeyDown}
          autoFocus
          style={{ width: '100%', marginBottom: '10px' }}
        />
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              padding: '10px',
              backgroundColor: index === selectedIndex ? '#ff0000' : '#f0f0f0',
              border: index === selectedIndex ? '2px solid blue' : '1px solid gray',
              margin: '5px 0',
              cursor: 'pointer'
            }}
            onClick={() => setSelectedIndex(index)}
          >
            {item} {index === selectedIndex ? '← SELECTED' : ''}
          </div>
        ))}
        <p>Use ↑↓ arrows, Esc to close</p>
      </div>
    </div>
  );
};

export default SimpleTest;